import { useTranslation } from 'react-i18next';
import { TKey } from '../i18n/types';

export const useNameTranslate = (name: TKey) => {
  const { t } = useTranslation();

  return t(name) || '';
};
